// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@keyframes fadeOut {
    from {
        opacity: 1;
    }
    to {
        opacity: 0;
    }
}

#csat-npc-dialog .csat_popup.fadeIn {
    animation: fadeIn 0.5s ease-in-out forwards;
}

#csat-npc-dialog .csat_popup.fadeOut {
    animation: fadeOut 0.5s ease-in-out forwards;
}

#csat-npc-dialog .csat_popup {
    position: absolute;
    bottom: 60px;
    left: 40px;
    background: white;
    width: 500px;
    border: solid 1px #aa9;
    animation: solid;
    box-shadow: #d0d0d0 1px 1px 2px;
    z-index: 1000;
    padding: 20px;
}

#csat-npc-dialog .csat_body {
    width: 100%;
    text-align: center;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

#csat-npc-dialog .csat_header_close {
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
}

#csat-npc-dialog .csat_body_ratings {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

#csat-npc-dialog .csat_body_ratings_likely_unlikely {
}

#csat-npc-dialog .csat {
    font-size: 30px;
    background: content-box radial-gradient(black, white);
}

#csat-npc-dialog .nps {
    font-size: 18px;
    border-radius: 100%;
    width: 30px;
    height: 30px;
    text-align: center;
    vertical-align: middle;
    line-height: 30px;
    color: white;
}

#csat-npc-dialog .rating {
    border-radius: 100%;
    margin: 0 5px;
}

#csat-npc-dialog .csat_footer {
    width: 100%;
    display: flex;
    gap: 10px;
}

#csat-npc-dialog .feedback_info {
    font-size: 11px;
    color: #999;
    align-self: center;
}

#csat-npc-dialog .csat_submit {
    bottom: 20px;
    right: 20px;
}

#csat-npc-dialog .csat.red {
    color: #f95c4a;
    border-color: #f95c4a;
}

#csat-npc-dialog .csat.orange {
    color: #f87c31;
    border-color: #f87c31;
}

#csat-npc-dialog .csat.yellow {
    color: #ffbf23;
    border-color: #ffbf23;
}

#csat-npc-dialog .csat.green {
    color: #89d89c;
    border-color: #89d89c;
}

#csat-npc-dialog .csat.darkgreen {
    color: #2dad4d;
    border-color: #2dad4d;
}

#csat-npc-dialog .nps.red {
    background-color: #f95c4a;
}

#csat-npc-dialog .nps.orange {
    background-color: #f87c31;
}

#csat-npc-dialog .nps.yellow {
    background-color: #ffbf23;
}

#csat-npc-dialog .nps.green {
    background-color: #89d89c;
}

#csat-npc-dialog .nps.darkgreen {
    background-color: #2dad4d;
}

#csat-npc-dialog .rating:hover {
    cursor: pointer;
    box-shadow: 0 0 0 3px #888;
}

#csat-npc-dialog .selected {
    box-shadow: 0 0 0 3px #555;
}

#csat-npc-dialog .likely {
    float: right;
    margin-right: 15px;
}

#csat-npc-dialog .unlikely {
    float: left;
    margin-left: 15px;
}

#csat-npc-dialog .likely,
#csat-npc-dialog .unlikely {
    font-size: 11px;
    color: #999;
}

#csat-npc-dialog .feedback_container {
    width: 100%;
}

#csat-npc-dialog .feedbackText {
    width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;IACtB,gBAAgB;IAChB,+BAA+B;IAC/B,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;AACA;;AAEA;IACI,eAAe;IACf,qDAAqD;AACzD;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,SAAS;AACb;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;;IAEI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf","sourcesContent":["@keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n    to {\n        opacity: 1;\n    }\n}\n\n@keyframes fadeOut {\n    from {\n        opacity: 1;\n    }\n    to {\n        opacity: 0;\n    }\n}\n\n#csat-npc-dialog .csat_popup.fadeIn {\n    animation: fadeIn 0.5s ease-in-out forwards;\n}\n\n#csat-npc-dialog .csat_popup.fadeOut {\n    animation: fadeOut 0.5s ease-in-out forwards;\n}\n\n#csat-npc-dialog .csat_popup {\n    position: absolute;\n    bottom: 60px;\n    left: 40px;\n    background: white;\n    width: 500px;\n    border: solid 1px #aa9;\n    animation: solid;\n    box-shadow: #d0d0d0 1px 1px 2px;\n    z-index: 1000;\n    padding: 20px;\n}\n\n#csat-npc-dialog .csat_body {\n    width: 100%;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n#csat-npc-dialog .csat_header_close {\n    cursor: pointer;\n    position: absolute;\n    right: 10px;\n    top: 10px;\n}\n\n#csat-npc-dialog .csat_body_ratings {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n}\n\n#csat-npc-dialog .csat_body_ratings_likely_unlikely {\n}\n\n#csat-npc-dialog .csat {\n    font-size: 30px;\n    background: content-box radial-gradient(black, white);\n}\n\n#csat-npc-dialog .nps {\n    font-size: 18px;\n    border-radius: 100%;\n    width: 30px;\n    height: 30px;\n    text-align: center;\n    vertical-align: middle;\n    line-height: 30px;\n    color: white;\n}\n\n#csat-npc-dialog .rating {\n    border-radius: 100%;\n    margin: 0 5px;\n}\n\n#csat-npc-dialog .csat_footer {\n    width: 100%;\n    display: flex;\n    gap: 10px;\n}\n\n#csat-npc-dialog .feedback_info {\n    font-size: 11px;\n    color: #999;\n    align-self: center;\n}\n\n#csat-npc-dialog .csat_submit {\n    bottom: 20px;\n    right: 20px;\n}\n\n#csat-npc-dialog .csat.red {\n    color: #f95c4a;\n    border-color: #f95c4a;\n}\n\n#csat-npc-dialog .csat.orange {\n    color: #f87c31;\n    border-color: #f87c31;\n}\n\n#csat-npc-dialog .csat.yellow {\n    color: #ffbf23;\n    border-color: #ffbf23;\n}\n\n#csat-npc-dialog .csat.green {\n    color: #89d89c;\n    border-color: #89d89c;\n}\n\n#csat-npc-dialog .csat.darkgreen {\n    color: #2dad4d;\n    border-color: #2dad4d;\n}\n\n#csat-npc-dialog .nps.red {\n    background-color: #f95c4a;\n}\n\n#csat-npc-dialog .nps.orange {\n    background-color: #f87c31;\n}\n\n#csat-npc-dialog .nps.yellow {\n    background-color: #ffbf23;\n}\n\n#csat-npc-dialog .nps.green {\n    background-color: #89d89c;\n}\n\n#csat-npc-dialog .nps.darkgreen {\n    background-color: #2dad4d;\n}\n\n#csat-npc-dialog .rating:hover {\n    cursor: pointer;\n    box-shadow: 0 0 0 3px #888;\n}\n\n#csat-npc-dialog .selected {\n    box-shadow: 0 0 0 3px #555;\n}\n\n#csat-npc-dialog .likely {\n    float: right;\n    margin-right: 15px;\n}\n\n#csat-npc-dialog .unlikely {\n    float: left;\n    margin-left: 15px;\n}\n\n#csat-npc-dialog .likely,\n#csat-npc-dialog .unlikely {\n    font-size: 11px;\n    color: #999;\n}\n\n#csat-npc-dialog .feedback_container {\n    width: 100%;\n}\n\n#csat-npc-dialog .feedbackText {\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
